import { configureStore } from '@reduxjs/toolkit';
import appReducer from '@redux/app/appSlice';
import authReducer from '@redux/auth/authSlice';
import gameReducer from '@redux/game/gameSlice';
import {
  sessionExpired,
  accountLocked,
} from '@redux/auth/authSlice';
import {
  systemMaintained,
} from '@redux/app/appSlice';

const store = configureStore({
  reducer: {
    app: appReducer,
    auth: authReducer,
    game: gameReducer,
  },
});

// ==================================================
// Global action, called from outside the components
// ==================================================
const sessionExpiredAction = () => {
  store.dispatch(sessionExpired());
};

// ==================================================
// Global action, called from outside the components
// ==================================================
const accountLockedAction = () => {
  store.dispatch(accountLocked());
};

// ==================================================
// Global action, called from outside the components
// ==================================================
const systemMaintainAction = (payload) => {
  store.dispatch(systemMaintained(payload));
};

// ==================================================

export {
  sessionExpiredAction,
  accountLockedAction,
  systemMaintainAction,
};

export default store;